export default function UiCheckBox( {id, label, value, onChange, description} ){

    return <div className="form-check">
            <input 
                type="checkbox" 
                className="form-check-input" 
                id={id} 
                name={id} 
                value={value}
                onChange={onChange}
                />
            <label 
                className="form-check-label" 
                htmlFor={id}>
                {label}
            </label>
            <p>{description}</p>
        </div>
    

}